import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SignOutSvg } from './assets/sign-out.svg';

const SignOutIcon = React.forwardRef((args, ref) => <SvgIcon component={SignOutSvg} ref={ref} {...args} />);

export default SignOutIcon;
